/**
 * Load Hotjar event listeners
 */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", function () {

	if (pmwDataLayer?.pixels?.hotjar?.site_id && !pmwDataLayer?.pixels?.hotjar?.loaded) {
		if (pmw.consent.canPixelBeFired("statistics", "Hotjar") && !pmwDataLayer?.pixels?.hotjar?.loaded) pmw.load_hotjar_pixel()
	}
})
